"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withdrawFundsOnMatic = void 0;
var abi_1 = require("@ethersproject/abi");
var types_1 = require("../types");
var encodeWithdraw = function (withdrawAmount) {
    return new abi_1.Interface(["function withdraw(uint256)"]).encodeFunctionData("withdraw(uint256)", [withdrawAmount]);
};
var withdrawTransaction = function (tokenAddress, withdrawAmount) { return ({
    to: tokenAddress,
    typeCode: types_1.CallType.Call,
    data: encodeWithdraw(withdrawAmount),
    value: "0",
}); };
exports.withdrawFundsOnMatic = function (tokenAddress, withdrawAmount) { return [
    withdrawTransaction(tokenAddress, withdrawAmount),
]; };
